import React, { useState } from "react";
import Search from "./components/Search";
import axios from "axios";
import NewsList from "./components/NewsList";

const App = () => {
  const [articles, serArticles] = useState([]);
  const onSearchSubmit = async (thema) => {
    try {
      const apiKey = process.env.REACT_APP_NEWSAPI_APIKEY;
      const q = thema;
      let today = new Date();
      let todayYear = today.getFullYear();
      let todayMonth = today.getMonth() + 1;
      let todayDate = today.getDate();
      let from = `${todayYear}-${todayMonth}-${todayDate}`;
      let last30days = today.getMonth();
      let to = `${todayYear}-${last30days}-${todayDate}`;
      const res = await axios.get(
        `https://newsapi.org/v2/everything?q=${q}&from=${from}&to=${to}&sortby=published&apiKey=${apiKey}`
      );
      serArticles(res.data.articles);
      console.log(res);
      console.log(from);
      console.log(to);
      if (res.data.totalResults === 0) {
        alert("お探しのニュースはございません");
      }
    } catch {
      alert("ニュースの取得に失敗しました。");
    }
  };
  return (
    <div className="search container" style={{ margin: "20px" }}>
      <h1 className="news-logo">News</h1>
      <Search onSubmit={onSearchSubmit} />
      <NewsList articles={articles} />
      <footer style={{ textAlign: "right" }}>
        <small>
          powered by <a href="https://newsapi.org">NewsAPI.org</a>
        </small>
      </footer>
    </div>
  );
};

export default App;
